import styles from "./styles.scss";
import { NavigationTabsProps } from "./types";
import { ForwardedRef, forwardRef } from "react";
import clsx from "clsx";
import { NavLink, useSearchParams } from "react-router-dom";
import { Tab } from "@/components/tab";

const NavigationTabsComponent = <T extends string = string>(
  { items, currentTab, search, className, onClick }: NavigationTabsProps<T>,
  ref: ForwardedRef<HTMLUListElement>,
) => {
  const [searchParams] = useSearchParams();

  const handleClick = (id: T) => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <ul className={clsx(styles.tabs, className)} ref={ref}>
      {items.map(({ id, label, link }) => {
        const searchParamsString =
          currentTab?.id === id ? searchParams.toString() : search;

        return (
          <li key={id} className={styles.tab}>
            <NavLink
              to={{ pathname: link, search: searchParamsString }}
              className={styles.link}
              onClick={() => handleClick(id)}
            >
              {({ isActive }) => (
                <Tab tabLabel={label} isActive={isActive}>
                  {label}
                </Tab>
              )}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

export const NavigationTabs = forwardRef(NavigationTabsComponent) as <
  T extends string | number = string | number,
>(
  props: NavigationTabsProps<T> & { ref?: ForwardedRef<HTMLUListElement> },
) => JSX.Element;
